module.exports = __webpack_public_path__ + "1f02f8ca718be0ccaa6aed9fd449d12d.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/cutScale/good.png
// module id = 855
// module chunks = 0